import { render, staticRenderFns } from "./PricingBackButton.vue?vue&type=template&id=adaecf18&scoped=true"
import script from "./PricingBackButton.vue?vue&type=script&lang=js"
export * from "./PricingBackButton.vue?vue&type=script&lang=js"
import style0 from "./PricingBackButton.vue?vue&type=style&index=0&id=adaecf18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adaecf18",
  null
  
)

export default component.exports